import React from 'react';
import { ErrorOutlineOutlined as ErrorOutlineOutlinedIcon } from '@mui/icons-material';
import { styled } from '@mui/material';
import { SAVE_TO_ADD_REFERENCE, THE_DOCUMENT } from 'common/constants/documents';
import { Alert } from 'components';
import { PendingReferenceProps } from './PendingReference.props';

const PREFIX = 'PendingReference';

const classes = {
  fileName: `${PREFIX}-fileName`,
};

const StyledAlert = styled(Alert)(() => ({
  [`& .${classes.fileName}`]: {
    fontWeight: 'bold',
    fontStyle: 'italic',
  },
}));

const PendingReference = ({ id, fileType, filename }: PendingReferenceProps) => (
  <StyledAlert
    key={id}
    severity="warning"
    isAlertVisible
    icon={<ErrorOutlineOutlinedIcon />}
    data-testid="cap-table-pending-document-reference">
    {THE_DOCUMENT}
    <span className={classes.fileName}>
      {filename}.{fileType}
    </span>
    {SAVE_TO_ADD_REFERENCE}
  </StyledAlert>
);

export default PendingReference;
